// 右侧固定导航图标
export const fixedModelImgs = {
  side_return:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fixedModelImg/side_return.png',
  side_signup:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fixedModelImg/side_signup.png',
  side_aftesale:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fixedModelImg/side_aftesale.png',
  side_shopping:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fixedModelImg/side_shopping.png',
};

//教师资格证
export const topicTeacherImgs = {
  topic_logo: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/topic_logo.png', //专题页头部LOGO
  topic_teacher_banner:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/topic_teacher_banner.png', //教师资格证banner
  title_kecheng:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/title_kecheng.png', //课程体系背景
  title_Class: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/title_Class.png', //单选班级背景
  kecheng_tuihuan:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/kecheng_tuihuan.png', //7天退换
  kecheng_shiting:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/kecheng_shiting.png', //试听
  kecheng_tuijian:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/kecheng_tuijian.png', //热门推荐
  kecheng_song: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/kecheng_song.png', //送
  kecheng_xiang:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/kecheng_xiang.png', //享
  bg_point: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/bg_point.png', //班级背景
  class_yes: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/class_yes.png', //配套服务
  industry_bg: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/industry_bg.png', //行业优势背景
  tittle_industry:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/tittle_industry.png', //行业优势
  industry_sircle_yellow:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/industry_sircle_yellow.png', //行业优势 - 薪资背景
  industry_sircle_red:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/industry_sircle_red.png', //行业优势 - 政策背景
  industry_add: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/industry_add.png', //行业优势 - 加号
  title_scoring:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/title_scoring.png', //提分体系背景
  scoring_bg: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/scoring_bg.png', //提分体系内容背景
  scoring_left: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/scoring_left.png', //提分体系标题背景左
  scoring_right:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/scoring_right.png', //提分体系标题背景右
  scoring_sircle:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/scoring_sircle.png', //提分体系百分比背景
  title_essential:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/title_essential.png', //必备资料库背景
  essential_bg: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/essential_bg.png', //必备资料库背景左
  essential_bg_red:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/essential_bg_red.png', //必备资料库背景左er
  essential_kecheng:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/essential_kecheng.png', //必备资料库背景左sa
  essential_pdf:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/essential_pdf.png', //必备资料库PDF
  title_problem:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/title_problem.png', //常见问题背景
  problem_bg: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/problem_bg.png', //常见问题背景
  mobile_bg: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/mobile_bg.png', //移动课堂背景
  mobile_iphone:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/mobile_iphone.png', //移动课堂手机
  mobile_right_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/mobile_right_bg.png', //移动课堂右边背景
  mobile_erweima:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/mobile_erweima.png', //移动课堂二维码
  mobile_yes_1: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/mobile_yes_1.png', //移动课堂勾
  mobile_bg_white:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/mobile_bg_white.png', //移动课堂勾
  scoring_1: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/scoring_1.png', //1
  scoring_2: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/scoring_2.png', //2
  scoring_3: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/scoring_3.png', //3
  sczx_code: 'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/sczx_code.jpg', //四川自修小程序二维码
  sczx_course_detail:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/sczx_course_detail.jpg', //四川自修课程详情
};

//消防工程师
export const topicFireEngineerImgs = {
  Banner_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/Banner_bg.png', //消防工程师banner
  course_hot:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_hot.png', //消防工程师 - 课程体系 - 推荐
  course_7_red:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_7_red.png', //消防工程师 - 课程体系 - title back
  course_7_blue:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_7_blue.png', //消防工程师 - 课程体系 - title back
  course_7_green:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_7_green.png', //消防工程师 - 课程体系 - title back
  course_x_yellow:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_x_yellow.png', //
  course_x_blue:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_x_blue.png', //
  course_x_green:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_x_green.png', //
  course_give:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_give.png', //
  course_point:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_point.png', //点
  title_course:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/title_course.png', //课程体系title背景
  course_class_red:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_class_red.png', //课程体系-1背景
  course_class_blue:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_class_blue.png', //课程体系-2背景
  course_class_green:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_class_green.png', //课程体系-3背景
  course_g_red:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_g_red.png', //课程体系-1-1背景
  course_g_blue:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_g_blue.png', //课程体系-2-1背景
  course_g_green:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_g_green.png', //课程体系-3-1背景
  kecheng_shiting:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/kecheng_shiting.png', //试听
  course_bg_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_bg_bg.png', //课程体系大背景
  class_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/class_bg.png', //单选班级大背景
  certificate_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/certificate_bg.png', //证书价值大背景
  title_class:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/title_class.png', //单选班级title背景
  title_certificate:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/title_certificate.png', //证书价值title背景
  title_question:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/title_question.png', //在线题库title背景
  certificate_title_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/certificate_title_bg.png', //证书价值title背景1
  question_star:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/question_star.png', //证书价值title背景1
  title_percent:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/title_percent.png', //自学VS百分网title背景
  percent_title_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/percent_title_bg_1.png', //自学VS百分网背景1
  percent_data_time:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/percent_data_time.png', //自学VS百分网背景2
  percent_data_Learn:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/percent_data_Learn.png', //自学VS百分网背景3
  percent_data_passing:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/percent_data_passing.png', //自学VS百分网背景4
  percent_g_yellow:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/percent_g_yellow.png', //自学VS百分网背景5
  percent_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/percent_bg.png', //
  title_problem:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/title_problem.png', //常见问题title背景
  mobile_classroom_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/mobile_classroom_bg.png', //
  mobile_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/mobile_bg.png', //
};

//执业药师
export const topicLicensedPharmacistImgs = {
  Banner_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/Banner_bg.png',
  title_course:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/title_course.png',
  course_bg_bgg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/course_bg_bgg.png',
  tlttle_class:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/tlttle_class.png',
  class_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/class_bg.png',
  analysis_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/analysis_bg.png',
  tltle_analysis:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/tltle_analysis.png',
  title_problem:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/title_problem.png',
  mobile_right_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/mobile_right_bg.png',
  mobile_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/mobile_bg.png',
  mobile_font:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/mobile_font.png',
  title_guidance:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/title_guidance.png',
  guidance_title_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/guidance_title_bg.png',
  guidance_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/guidance_bg.png',
  tlttle_strategy:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/tlttle_strategy.png',
  strategy_stage:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/strategy_stage.png',
  strategy_class_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/strategy_class_bg.png',
  strategy_sceond_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/strategy_sceond_bg.png',
  guidance_star_solid:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/guidance_star_solid.png',
  guidance_star_hollow:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/licensedPharmacist/guidance_star_hollow.png',
};

//自考
export const selfStudyImgs = {
  xq_Banner_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/xq_Banner_bg.png',
  xq_title_course:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/xq_title_course.png',
  course_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_bg.png',
  xq_title_class:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/xq_title_class.png',
  class_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/class_bg.png',
  course_hot:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_hot.png',
  course_class_vip:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_class_vip.png',
  course_fu_yesllow:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_fu_yesllow.png',
  course_bz_red:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_bz_red.png',
  course_class_yesllow:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_class_yesllow.png',
  course_class_blue:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_class_blue.png',
  course_class_green:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_class_green.png',
  course_point:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_point.png',
  course_g_yesllow:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_g_yesllow.png',
  course_g_green:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_g_green.png',
  course_g_blue:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_g_blue.png',
  course_fu_green:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_fu_green.png',
  course_fu_blue:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/course_fu_bliue.png',
  gc_Banner_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/gc_Banner_bg.png',
  gc_title_class:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/gc_title_class.png',
  gc_title_course:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/gc_title_course.png',
  gs_Banner_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/gs_Banner_bg.png',
  gs_title_course:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/gs_title_course.png',
  gs_title_class:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/gs_title_class.png',
  yx_Banner_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/yx_Banner_bg.png',
  yx_title_class:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/yx_title_class.png',
  yx_title_course:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/selfStudy/yx_title_course.png',
};
//初级会计师
export const topicJuniorAccountantImgs = {
  Banner_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/Banner_bg.png',
  course_point:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/fireEngineer/course_point.png', //点
  title_course:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/title_course.png',
  course_class_blue:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/course_class_blue.png',
  course_class_purple:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/course_class_purple.png',
  course_class_red:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/course_class_red.png',
  course_7_blue:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/course_7_blue.png',
  course_7_purple:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/course_7_purple.png',
  course_7_red:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/course_7_red.png',
  kecheng_shiting:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/kecheng_shiting.png', //试听
  course_bg:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/course_bg.png',
  course_circle_song:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/course_circle_song.png',
  course_circle_xiang:
    'http://bbsresources.oss-cn-hangzhou.aliyuncs.com/wangxiao/topic/juniorAccountant/course_circle_xiang.png',
};



// WEBPACK FOOTER //
// ./src/images/topicImg.js